/**
 * LeaveMenu: 나가기/종료 드롭다운 메뉴.
 *
 * v1 원본: RenewalComponents/Headers/Footer/FooterPresenter.js (lines 197-221)
 * v1 CSS: .rtc_new3 .newHeader_btnItem.open .viewerHeader__layer
 *         .layer_exitBox
 */
import React, { useState, useRef, useEffect } from 'react';

interface LeaveMenuProps {
  isMaster: boolean;
  onHangup: () => void;
  onEndMeetingForAll?: () => void;
}

const LeaveMenu: React.FC<LeaveMenuProps> = ({ isMaster, onHangup, onEndMeetingForAll }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isOpen) return;
    const handleClick = (e: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [isOpen]);

  return (
    <div ref={containerRef} className={`newHeader_btnItem${isOpen ? ' open' : ''}`}>
      <button
        type="button"
        className="newHeader_btn newHeader_btn--dropdown"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="newHeader_btnIcon icoLeave" />
        <p className="newHeader_btnText">나가기</p>
      </button>
      <div className="viewerHeader__layer posRight">
        <div className="layer_exitBox">
          <p>회의를 나가시겠습니까?</p>
          <div className="exit_btnBox">
            <button
              type="button"
              className="common_round_btn closeBtn"
              onClick={() => { setIsOpen(false); onHangup(); }}
            >
              회의 나가기
            </button>
            {isMaster && (
              <button
                type="button"
                className="common_round_btn allCloseBtn"
                onClick={() => { setIsOpen(false); onEndMeetingForAll?.(); }}
              >
                모두에게 회의 종료
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeaveMenu;
